import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import useSmoothScroll from "./lib/useSmoothScroll";
import Home from "./pages/Home";
import Book from "./pages/Book";
import Track from "./pages/Track";
import Plans from "./pages/Plans";
import Pricing from "./pages/Pricing";
import ThankYou from "./pages/ThankYou";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import AuthCallback from "./pages/AuthCallback";
import RiderPortal from "./pages/RiderPortal";
import RiderRegister from "./pages/RiderRegister";
import SectorLanding from "./pages/SectorLanding";
import AreasIndex from "./pages/AreasIndex";
import ServiceLanding from "./pages/ServiceLanding";
import ServicesIndex from "./pages/ServicesIndex";
import BestLaundryGurugram from "./pages/BestLaundryGurugram";
import SameDayLaundryGurugram from "./pages/SameDayLaundryGurugram";
import GuidesIndex from "./pages/GuidesIndex";
import GuideArticle from "./pages/GuideArticle";
import BlogIndex from "./pages/BlogIndex";
import BlogArticle from "./pages/BlogArticle";
import Brand from "./pages/Brand";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";

function AppRoutes() {
  const location = useLocation();
  useSmoothScroll();
  // Handle Emergent OAuth callback: session_id arrives in URL hash fragment.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/track" element={<Track />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/book" element={<ProtectedRoute><Book /></ProtectedRoute>} />
      <Route path="/plans" element={<ProtectedRoute><Plans /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/rider" element={<RiderPortal />} />
      <Route path="/rider/register" element={<RiderRegister />} />
      <Route path="/areas" element={<AreasIndex />} />
      <Route path="/laundry/:sectorSlug" element={<SectorLanding />} />
      <Route path="/services" element={<ServicesIndex />} />
      <Route path="/services/:serviceSlug" element={<ServiceLanding />} />
      <Route path="/best-laundry-gurugram" element={<BestLaundryGurugram />} />
      <Route path="/same-day-laundry-gurugram" element={<SameDayLaundryGurugram />} />
      <Route path="/guides" element={<GuidesIndex />} />
      <Route path="/guides/:guideSlug" element={<GuideArticle />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:blogSlug" element={<BlogArticle />} />
      <Route path="/brand" element={<Brand />} />
      <Route path="/about" element={<Brand />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App font-body bg-rw-bg text-rw-ink min-h-screen">
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              style: {
                background: "#1A1A24",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.08)",
              },
            }}
          />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
